
import { Component, Vue, Watch } from "vue-property-decorator";
import debounce from "debounce";
import { ROWS_PER_PAGE } from "@/utils/constants";

@Component
export default class Companies extends Vue {

    @Watch("search")
    public handlerSearch = debounce(this.getMainData, 500);

    private rows: object[] = [];
    private headers: object[] = [
        {value: "id", sortable: true},
        {value: "name", sortable: true},
        {value: "status", sortable: true},
        {value: "company", sortable: false},
        {value: "master", sortable: false},
        {value: "logAsMaster", sortable: false},
        {value: "createdAt", sortable: true},
        {value: "updatedAt", sortable: true},
    ];
    private totalItems: number = 0;
    private loading: boolean = false;
    private search: string = "";
    private pagination: any = {
        sortDesc: [true],
        sortBy: ["updatedAt"],
        mustSort: false,
        multiSort: false,
        page: 1,
        itemsPerPage: 10,
    };

    private ROWS_PER_PAGE = ROWS_PER_PAGE;

    @Watch("pagination", {deep: true})
    public handler() {
        this.getMainData();
    }

    private getMainData() {
        this.loading = true;
        this.rows = [];
        return this.$store.dispatch("admin/keys/read", {
          query: {
            ...this.pagination,
            search: this.search,
          },
        }).then((res) => {
            this.rows = res.rows;
            this.totalItems = res.count;
        }).catch((error) => {
            this.$store.commit("alerts/displayHttpError", { error });
        }).finally(() => {
            this.loading = false;
        });
    }

    private getMaster(key: any): any {
      return key.Company.ManagementRelation[0].Subordinate;
    }

    private logAs(key) {
      this.$store.dispatch("auth/logAs", {
        user: this.getMaster(key),
      });
    }

}
